export enum KeySymbol {
  Command = '⌘',
  Shift = '⇧',
  Option = '⌥',
  Control = '⌃',
  Hyper = '✦',
  Super = '❖',
  Escape = '⎋',
}
